module.exports = __webpack_public_path__ + "img/timesheet-ebadge-emt.f0a5cee7.png";